import React from 'react';

import { BaseColorKeys, PureColorKeys } from '../../theme';
import Chip, { ChipProps } from '../Chip';

export interface UserDisabledChipProps extends ChipProps {
  disabled: boolean,
  color?: PureColorKeys | BaseColorKeys,
}

const UserDisabledStateChip = ({ disabled, ...rest }: UserDisabledChipProps) => (
  disabled ? (
    <Chip label="Disabled" variant="filled" color="error" {...rest} />
  ) : (
    <Chip label="Enabled" variant="filled" color="success" {...rest} />
  )
);

export default UserDisabledStateChip;
